﻿
$(document).ready(function () {

    // init HomePage hero carousel...
    if (jQuery().slick && $('.image-slider__slide-images')) {

        // attach an initialise event to remove the style attributes hiding any slide contentent
        $('.image-slider__slide-images').on('init', function (e, s) {
            $('.image-slider__slide-images:not(:first)').removeAttr('style');
            $('.image-slider__slide-contents div:not(:first)').removeAttr('style');
            $('.image-slider__slide-content-wrapper:not(:first)').removeAttr('style');
            $('.image-slider__slide-image-wrapper:not(:first)').removeAttr('style');
        })

        // this consists of 2 slick sliders, one with pagers and acting as the paretn controller for the other
        $('.image-slider__slide-contents').slick({
            autoplay: false,
            speed: 300,
            arrows: false,
            dots: false
        });        
        $('.image-slider__slide-images').slick({
            autoplay: false,
            speed: 300,
            arrows: true,
            dots: true,
            appendDots: $('.image-slider__pager'),
            dotsClass: 'carousel-dots',
            customPaging: function (slider, i) {
                return '<a href="#" class="carousel-dot"></a>';
            },
            appendArrows: $('.image-slider__pager'),
            asNavFor: '.image-slider__slide-contents',
            prevArrow: '<button type="button" class="slick-prev mf mf-corp-arrow-left"></button>',
            nextArrow: '<button type="button" class="slick-next mf mf-corp-arrow-right"></button>',
        });
    }
})